import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss']
})
export class ErrorScreenComponent implements OnInit {

  constructor() { }

  error: AnimationOptions = {
    path: './assets/json/error.json',
    loop: true
  };

  ngOnInit(): void {
  }

}
